// extracted by mini-css-extract-plugin
export default {"inner":"Checkbox_inner__-y1go","input":"Checkbox_input__pimgk","checkmark":"Checkbox_checkmark__T1v8z","label":"Checkbox_label__5aQql"};